import React from "react";
import { useHistory } from "react-router-dom";
import { FileResource, ResourceType } from "types/graphqlapi";
import { fetchFileResourcesBySubjectIdQuery } from "utils/apis/fileResource";
import { fetchUsedResourceBySubjectIdQuery } from "utils/apis/usedResouse";
import { getStorageOutput } from "utils/common";

export type DisplayFileResource = {
  used: boolean;
  src?: string;
  typeDescription?: string;
} & FileResource;

export const useFileResource = () => {
  const history = useHistory();
  const [fileResourceList, setFileResourceList] = React.useState<
    DisplayFileResource[]
  >([]);

  // リソース取得処理
  const fetchFileResource = async (subjectId: string) => {
    try {
      const result = await fetchFileResourcesBySubjectIdQuery(subjectId);
      const fetchUsedResourceResult = await fetchUsedResourceBySubjectIdQuery(
        subjectId
      );
      const usedResourceList = fetchUsedResourceResult || [];

      const displayFileResourceList = await Promise.all(
        result.map(async (fileResource) => {
          const src = await getStorageOutput(fileResource.url);
          const getTypeDescription = (fileType: ResourceType) => {
            switch (fileType) {
              case ResourceType.IMAGE:
                return "画像";
              case ResourceType.VIDEO:
                return "動画";
              default:
                return "その他";
            }
          };

          const fileWithSrcTypeDescription = {
            ...fileResource,
            src,
            typeDescription: getTypeDescription(fileResource.type),
            used: usedResourceList.some(
              (usedResource) => usedResource.key === fileResource.url
            ),
          };

          return fileWithSrcTypeDescription;
        })
      );

      setFileResourceList(displayFileResourceList);
    } catch (error) {
      console.error(error);
      alert("エラーが発生しました。");
      history.replace("/auth/login");
    }
  };

  return {
    fileResourceList,
    fetchFileResource,
  };
};
